import React, { useState } from "react";
import { Row, Col, Modal } from "antd";
import "../../assets/css/ponentes.css";

import { CaretLeftFilled, CaretRightFilled, CloseOutlined } from "@ant-design/icons";

import ponente1 from "../../assets/images/2025/ponentes/casaduana_BrendaAngeles.png";
import ponente2 from "../../assets/images/2025/ponentes/casaduana_FernandoMejia.png";
import ponente3 from "../../assets/images/2025/ponentes/casaduana_GeorginaEstrada.jpg";
import ponente4 from "../../assets/images/2025/ponentes/casaduana_IrvingBecerril.jpg";
import ponente5 from "../../assets/images/2025/ponentes/casaduana_PabloMejia.png";
import ponente6 from "../../assets/images/2025/ponentes/casaduana_MarioOsorio.jpg";


const expositor = [
  //{nombre:'', img: avatar,img_hover:avatar_hover, hash:'/conferencistas#' },
  {
    nombre: "Brenda Angeles",
    empresa: "",
    cargo: "",
    img: ponente1,
    url: '',
    semblanza: null,
  },{
    nombre: "Fernando Mejía",
    empresa: "",
    cargo: "",
    img: ponente2,
    url: '',
    semblanza: null,
  },{
    nombre: "Georgina Estrada",
    empresa: "",
    cargo: "",
    img: ponente3,
    url: '',
    semblanza: [<>Licenciada en Derecho por la Universidad Autónoma de Coahuila; Maestra en Derecho Fiscal por el Colegio de Ciencias Jurídicas, y
Maestra en Derecho Aduanero y Derecho de Comercio Exterior por el Centro de Estudios Universitario de Estudios Jurídicos. Doctora
Honoris Causa, por el Claustro Doctoral Honoris Causa A.C., Doctora Honoris Causa, por la Organización Mundial de Líderes, organismo
internacional, Doctora Honoris Causa, por el Claustro Doctoral “Honores Vero Lumine”
, Doctoranda en Derecho Aduanero y Derecho
de Comercio Exterior.<br /><br />
30 años de experiencia, Presidenta y fundadora de la Asociación de Mujeres Aduaneras "AMA"
, organismo que promueve la sororidad,
la cultura contributiva y el cumplimiento fiscal y aduanero. Ha impulsado el emprendimiento de mujeres mexicanas asesorándolas en
trámites de importación y exportación, convencida de que su fortalecimiento es una estrategia para la reactivación economía de
diversos sectores productivos en México , asimismo ha brindado apoyo legal al emprendimiento de mujeres artesanas de Perú.<br /><br />

Experta Aduanera" acreditada por la Organización Mundial de Aduanas (OMA), en Derechos de Propiedad Intelectual y Gestión de
Riesgos. Certificada por el "CONOCER' como Oficial de Cumplimiento en Materia Aduanera y de Comercio Exterior, y Especialista en
IMMEX, Forma parte de la lista de expertos del Fondo Monetario Internacional, consultora del Banco Mundial y del Banco
Interamericano de Desarrollo. Ha proporcionado asistencia técnica y capacitación en materia aduanera y de comercio exterior a
aduanas de distintos países, principalmente de LATAM.<br /><br />

Fue funcionaria en el Servicio de Administración Tributaria por 24 años, adscrita a las Administraciones Generales de Aduanas, Jurídica
y de Auditoría de Comercio Exterior, en ésta última como Administradora Central de Apoyo Jurídico de Auditoría de Comercio
Exterior”
. Fue integrante del Comité Técnico de Valoración Aduanera de la Organización Mundial de Aduanas (OMA). en la Comisión de
Comercio Exterior (COCEX) que preside la Secretaría de Economía y colaboró en las mesas de trabajo de las negociaciones del T-MEC.
Llevó a cabo esquemas de facilitación aduanera y medidas de autocorrección que impactaron a distintos instrumentos normativos
como el Despacho Aduanero Conjunto, RFE, entre otros. Participó en la Comisión de Comercio Exterior (COCEX) que preside la
Secretaría de Economía y colaboró en las mesas de trabajo de las negociaciones del T-MEC, y en la defensa legal para obtener
.resoluciones favorables al SAT.<br /><br />
Realizó cursos sobre gestión de riesgos, despacho aduanero, facilitación aduanera, valoración aduanera, combate contra el fraude
aduanero, prevención de lavado de dinero y propiedad intelectual, en la OMA en Bruselas, Bélgica, y en la Aduana Japonesa, Tokio y
Kobe, Japón. Por parte del Departamento de Justicia de Estados Unidos capacitación enfocada en gestión de riesgos. En la
Academia, ha sido catedrática en maestría, de la materia de derecho aduanero, y participa con distintos organismos en diplomados
de comercio exterior. Articulista y conferencista, en varias ocasiones la revista “Estrategia Aduanera” la ha considerado dentro de los
Principales Asesores en Comercio Exterior de México”
, en 2025, nombrada como la Asesora del año.<br /><br />
Forma parte de las comisiones de aduanas, de la defensa de la legalidad y de inclusión y diversidad, de la CONCAMIN, Consejera de la
Asociación Nacional de Importadores y Exportadores de la República Mexicana, integrante de la comisión de comercio exterior del
CCPM; de la Comisión de Comercio Internacional del Instituto Mexicano de Contadores Públicos, del Instituto Mexicano de Especialistas
en Comercio Exterior, de la Barra Mexicana de Abogados, del Ilustre Nacional Colegio de Abogados de México, miembro del Women
Economic Forum (WEF) y del G100, dentro del ALA:
"Integridad, Cumplimiento y Globalización"
, como “Country Advisory Council”
, así
como integrante del colectivo 50+1 (Grupo de mujeres en pro de la lucha por los DDHH de las mujeres en el mundo).</>],
  },{
    nombre: "Irving Becerril",
    empresa: "",
    cargo: "",
    img: ponente4,
    url: '',
    semblanza: [<>Especialista en seguridad de la cadena de suministros, comercio exterior, análisis de riesgos y
autotransporte de carga. Fue Administrador del Programa Operador Económico Autorizado de México
hasta febrero de 2025, liderando la implementación de estándares internacionales de seguridad en
cadena de suministros y facilitando el comercio exterior para empresas nacionales e internacionales,
Acuerdos de Reconocimiento Mutuo entre México y otros países, inclusión de nuevas figuras en dicho
programa y participó activamente en la actualización de la normatividad aplicable.<br /><br />
Profesionista con licenciatura en Ciencias Políticas y Administración Políticas por la Universidad
Autónoma del Estado de México (UAEMEX). Actualmente se desempeña como Consultor Master en
GISCO Consulting donde lidera proyectos de consultoría estratégica en comercio exterior y seguridad
de cadena de suministros. Cuenta con la certificación internacional ISO 31000 Risk Manager, otorgada
por el organismo canadiense PECB, que avala su expertise en gestión de riesgos corporativos y
procesos de auditoría.<br /><br />
Cuenta con más de quince años de experiencia en la Administración Pública, desarrollándose en áreas
de Autotransporte Federal de Carga en la Secretaria de Infraestructura Comunicaciones y Transportes,
Administración General de Aduanas y Auditoría de Comercio Exterior en el SAT.<br /><br />
Desde 2010 colaboró en el desarrollo del Programa OEA, ha capacitado y formado auditores de
seguridad en cadena de suministros para el SAT y otros países, además trabajar con autoridades de
EUA (CTPAT), Canadá, Colombia, Chile, Argentina, Perú, Paraguay, Uruguay, El Salvador, Israel, Corea
del Sur y Hong Kong.<br /><br />
Ha sido ponente y facilitador clave en foros y capacitaciones de alto nivel, colaborando con organismos
internacionales como el Banco Interamericano de Desarrollo (BID), la Comisión Interamericana contra
el Terrorismo (CICTE-OEA), y las cámaras industriales y logísticas más relevantes de México (INDEX,
CANACAR, CAAAREM, CLAA), así como con instituciones de seguridad como la Policía Federal y la
División de Gendarmería. Su labor ha sido fundamental para fortalecer la vinculación estratégica entre
los sectores público, privado e internacional.</>],
  },{
    nombre: "Pablo Mejía",
    empresa: "",
    cargo: "",
    img: ponente5,
    url: '',
    semblanza: null,
  },{
    nombre: "Mario Osorio",
    empresa: "",
    cargo: "",
    img: ponente6,
    url: '',
    semblanza: [<>Estudios<br /><br />

<strong>Licenciatura en Derecho</strong><br />
Titulado<br /><br />

<strong>Maestría en Derecho Fiscal</strong><br />
Titulación pendiente<br /><br />

<strong>Maestría en Derecho Corporativo</strong><br /><br />

<strong>Norma de Competencia Laboral</strong><br />
Representación del Agente Aduanal en los Actos y Formalidades del Despacho Aduanero<br />
Comité de Gestión por Competencias de Servicios Aduaneros<br />
SEP autorización N° 068115 — CONOCER folio S011339212<br /><br />

<hr style={{color:'#ffffff'}} /><br /><br /> 

Experiencia Laboral<br /><br />

<strong>Actualmente – Attorney Brokers and Consultants de México SC</strong><br />
Director<br /><br />

<strong>Enero – Junio 2023 — Agencia Nacional de Aduanas de México</strong><br />
Director Central de Recaudación<br /><br />

<strong>2009 – 2014 — Accel Comercial S.A., Recinto Fiscalizado Estratégico</strong><br />
CD Juárez<br />
Administrador Área Aduanas<br /><br />

<strong>2007 – 2008 — Schlumberger NAFTA / Oficina Houston TX</strong><br />
JG Customs / Expeditors<br />
Supervisor de revisión en origen<br /><br />

<strong>2001 – 2006 — Consultores Internacionales de Comercio Exterior</strong><br />
AA Virgilio Vallejo Montaño<br />
Mandatario<br /><br />

<strong>1994 – 2001 — Consultores y Capacitadores de Comercio Exterior (COCEX)</strong><br />
Clasificador Arancelario<br /><br />

<hr style={{color:'#ffffff'}} /><br /><br /> 

Experiencia Docente<br /><br />

<strong>Centro Universitario de Cd. Juárez</strong><br />
Materia: Comercio Exterior<br />
Nivel: Maestría en Comercio Internacional y Gestión Aduanera<br /><br />

<strong>Centro Universitario de Ciudad Juárez</strong><br />
Materia: Diplomado en Comercio Internacional<br />
Nivel: Lic. en Derecho y Lic. en Administración Aduanera<br /><br />

<strong>Instituto de Capacitación Aduanera Integral / CAAAREM</strong><br />
Materia: Capacitación a Agentes y Mandatarios Aduanales<br />
Nivel: Examen de norma de competencia laboral<br /><br />

<strong>Instituto de Capacitación Aduanera Integral / División Policía Federal Preventiva</strong><br />
Delegación Cd. Juárez<br />
Materia: Aduanas y Fronteras<br />
Nivel: Diplomado<br /><br />

<strong>Instituto de Capacitación Aduanera Integral / Secretaría de Economía</strong><br />
Delegación Cd. Juárez (NICE)<br />
Materia: Clasificación Arancelaria / Normas Oficiales Mexicanas<br />
Nivel: Diplomado
</>],
  }
];
const Speakers = (props) => {
  const [selec_person, setSelectPerson] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleCancel = () => {
    setIsModalVisible(false);
  };


  let ver_texto_modal = expositor
    .filter((item, index) => {
      if (selec_person === index) {
        return true;
      } else {
        return false;
      }
    })
    .map((seccion, index) => {
      return (
        <Col xs={24}>
          <p className="semblanza_modal">{seccion.semblanza}</p>
          <br />
        </Col>
      );
    });


  return (
  <>
    <Row justify="center" align="middle" className="">

  <Col span={24}>
    <p className="titulo_ponentes">Speakers</p>
  </Col>

  <Col xs={22} md={18}>
    <Row justify="space-around">
      

      {expositor.map((item, index) => (
  <Col xs={12} md={6} key={index} className="ponente-card">
    <div className="ponente-wrapper">
      
      <img src={item.img} className="ponente-img" alt={item.nombre} />

      <p className="ponente-nombre">{item.nombre}</p>

      <div className="linea_ponente"></div>

      <p className="ponente-cargo">{item.cargo}</p>

      {item.semblanza && item.semblanza.length > 0 && (
        <button
          className="btn-semblanza"
          onClick={() => {
            setSelectPerson(index);
            setIsModalVisible(true);
          }}
        >
          Ver semblanza
        </button>
      )}

    </div>
  </Col>
))}

    </Row>
  </Col>
</Row>

    {/* MODAL */}
<Modal
  open={isModalVisible}
  onCancel={handleCancel}
  footer={false}
  closeIcon={<CloseOutlined style={{ color: "#ffffff" }} />}
  className="modal-ponente"
>
  <div className="modal-header-ponente">
    <h2 className="color_blanco">{expositor[selec_person].nombre}</h2>
    {expositor[selec_person].cargo && (
      <p style={{ margin: 0, opacity: 0.8 }}>{expositor[selec_person].cargo}</p>
    )}
  </div>

  <div className="modal-body-ponente">
    {ver_texto_modal}
  </div>
</Modal>

  </>
);

};
export default Speakers;
